import { useTranslation } from "react-i18next";
import { Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import Editor from "shared/components/Editor/Editor";
import { GenericButton } from "shared/ui-basics/index";
import styled from "styled-components";
export function VersionPreviewModal({ isOpen, onClose, iframeUrl, versionName, versionDescription,onRestore ,onDelete}) {

	const { t } = useTranslation();

	return (
		<Modal fade={false} isOpen={isOpen} size="xl" centered={true} toggle={onClose}>
			<ModalHeader className="pt-1 pb-1" toggle={onClose}>
				<span className="small-title">{t("VERSION_PREVIEW")}</span>
			</ModalHeader>
			<Body > 
                <Bold className='p-3 pb-0'>{versionName}</Bold>
                {versionDescription && (    
                    <Text className='p-3 pb-0'><Editor value={versionDescription} disabled={true} /> </Text>
                )}

				<div className="p-2 pb-0">
				{<Frame src={iframeUrl}></Frame>}

				</div>
			</Body>
            {<ModalFooter className="d-flex justify-content-between">
                <GenericButton
                    variant="danger-outline"
                    icon='TRASH'
                    iconClassName='me-2'
                    onClick={() => {
                        onDelete();
                        onClose();
                    }}>
                    {t("DELETE")}
                </GenericButton>
                <GenericButton
                    variant="dark"
                    icon='undo'
                    iconClassName='me-2'

                    onClick={() => {
                        onRestore();
                        onClose();
                    }}>
                    {t("RESTORE_THIS_VERSION")}
                </GenericButton>
            </ModalFooter>}
		</Modal>
	);
}
const Frame = styled.iframe`
	width: 100%;
	height: 922px;
	overflow: auto;
	zoom: 0.7;
	border-radius: 8px;
background: var(--color-Grey-Background, #F5F5F5);
`;
const Body = styled(ModalBody)`
	overflow: auto;
    width: 100%;  
    height: 100%;
	padding:  0px;
	/* @media (max-height: 800px) {
		min-height: 700px;
		max-height: 700px;
	} */
`;


const Text = styled.div`
	color: ${props=> props.color ||' #333333' };
	font-family: Inter;
	font-size: 14px;
	font-style: normal;
	font-weight: 400;
	padding: 4px;
`;

const Bold = styled.div`
	color: #333333;
	font-family: "Inter";
    font-size: 38px;
	font-weight: 500;
	line-height: normal;
`;